const MOUSE_POSITION_TOKEN_PATTERN = /\$(clientx|clienty)\$/g
const MOUSE_POSITION_SELECTOR = '[data-lay-mouse-position]'
const SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION']

let clientX = 0
let clientY = 0

const normalizeRoot = (root) => {
	if (!root) {
		return document.body
	}
	if (root.jquery) {
		return root[0]
	}
	return root
}

const shouldSkipTextNode = (node) => {
	const parent = node && node.parentElement
	if (!parent || SKIP_TAGS.includes(parent.tagName)) {
		return true
	}
	return parent.closest(MOUSE_POSITION_SELECTOR) !== null
}

const getAxisFromToken = (token) => (token.toLowerCase() === 'clienty' ? 'y' : 'x')

const getValue = (axis) => String(axis === 'y' ? clientY : clientX)

const createMousePositionElement = (axis) => {
	const el = document.createElement('span')
	el.className = 'lay-mouse-position'
	el.setAttribute('data-lay-mouse-position', axis)
	el.textContent = getValue(axis)
	return el
}

const replaceMousePositionTokensInTextNode = (node) => {
	if (shouldSkipTextNode(node) || !node.nodeValue.includes('$client')) {
		return false
	}

	MOUSE_POSITION_TOKEN_PATTERN.lastIndex = 0
	const matches = Array.from(node.nodeValue.matchAll(MOUSE_POSITION_TOKEN_PATTERN))
	if (!matches.length) {
		return false
	}

	const fragment = document.createDocumentFragment()
	let lastIndex = 0
	matches.forEach((match) => {
		if (match.index > lastIndex) {
			fragment.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex, match.index)))
		}
		fragment.appendChild(createMousePositionElement(getAxisFromToken(match[1])))
		lastIndex = match.index + match[0].length
	})
	if (lastIndex < node.nodeValue.length) {
		fragment.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex)))
	}

	node.parentNode.replaceChild(fragment, node)
	return true
}

const replaceRawTokens = (root) => {
	if (!root) {
		return
	}
	if (root.nodeType === Node.TEXT_NODE) {
		replaceMousePositionTokensInTextNode(root)
		return
	}
	if (!root.querySelectorAll) {
		return
	}

	const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
		acceptNode: (node) => (shouldSkipTextNode(node) || !node.nodeValue.includes('$client') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
	})
	const nodes = []
	while (walker.nextNode()) {
		nodes.push(walker.currentNode)
	}
	nodes.forEach(replaceMousePositionTokensInTextNode)
}

const updateMousePositionElements = (root) => {
	const target = normalizeRoot(root)
	if (!target) {
		return
	}

	const updateElement = (el) => {
		const axis = el.getAttribute('data-lay-mouse-position') === 'y' ? 'y' : 'x'
		el.textContent = getValue(axis)
	}

	if (target.matches && target.matches(MOUSE_POSITION_SELECTOR)) {
		updateElement(target)
	}
	if (target.querySelectorAll) {
		target.querySelectorAll(MOUSE_POSITION_SELECTOR).forEach(updateElement)
	}
}

const updatePointerPosition = (x, y) => {
	if (!Number.isFinite(x) || !Number.isFinite(y)) {
		return
	}
	clientX = Math.round(x)
	clientY = Math.round(y)
	updateMousePositionElements(document.body)
}

const handleMouseEvent = (event) => {
	updatePointerPosition(event.clientX, event.clientY)
}

const getTouchPoint = (event) => {
	if (event.changedTouches && event.changedTouches.length) {
		return event.changedTouches[0]
	}
	if (event.touches && event.touches.length) {
		return event.touches[0]
	}
	return null
}

const handleTouchEvent = (event) => {
	const touch = getTouchPoint(event)
	if (touch) {
		updatePointerPosition(touch.clientX, touch.clientY)
	}
}

const updateMousePositionPlaceholders = (root) => {
	const target = normalizeRoot(root)
	if (!target) {
		return
	}

	replaceRawTokens(target)
	updateMousePositionElements(target)
}

const mouse_position_controller = {
	i: function () {
		updateMousePositionPlaceholders(document.body)
		document.addEventListener('mousemove', handleMouseEvent, { passive: true })
		document.addEventListener('touchstart', handleTouchEvent, { passive: true })
		document.addEventListener('touchmove', handleTouchEvent, { passive: true })
		document.addEventListener('touchend', handleTouchEvent, { passive: true })
		window.laytheme.on('newpageshown', function () {
			updateMousePositionPlaceholders(document.body)
		})
		window.laytheme.on('content_ready', function (typeOfContentThatIsReady, $target) {
			updateMousePositionPlaceholders($target)
		})
	},
	update: updateMousePositionPlaceholders,
}

export default mouse_position_controller
